import React, {useMemo} from 'react';
import {Box, Button, FormHelperText} from '@mui/material';

export const parseJson = (input) => {
    if (!input || input.trim().length === 0)
        return {parsed: null, error: null};
    try {
        const parsed = JSON.parse(input);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed))
            return {parsed: parsed, error: null};
        return {parsed: null, error: "Invalid JSON: expected an object"};
    } catch (e) {
        return {parsed: null, error: `Invalid JSON: ${e.message}`};
    }
}

export const formatJson = (input) => {
    const {parsed, error} = parseJson(input);
    if (error || !parsed)
        return {formatted: null, error: error};
    return {formatted: JSON.stringify(parsed, null, 2), error: null};
}

const JsonTextarea = (props) => {
    const {value, placeholder, onChange, error = null, disabled} = props;

    const jsonError = useMemo(() => parseJson(value).error, [value]);

    const handleFormat = () => {
        const {formatted} = formatJson(value);
        if (formatted)
            onChange(formatted);
    }

    return (
        <React.Fragment>
            <Box sx={{display: 'flex', justifyContent: 'flex-end', width: 500}}>
                <Button
                    size="small"
                    disabled={disabled || !!jsonError || !value}
                    onClick={handleFormat}>Format JSON</Button>
            </Box>
            <textarea
                value={value || ""}
                placeholder={placeholder}
                disabled={disabled}
                spellCheck="false"
                onChange={(event) => onChange(event.target.value)}
                style={{
                    display: 'block',
                    minHeight: 200,
                    width: 500,
                    boxSizing: 'border-box',
                    padding: '8px',
                    border: '1px solid',
                    borderColor: jsonError ? '#d32f2f' : '#c4c4c4',
                    borderRadius: 4,
                    color: '#333333',
                    fontFamily: 'monospace',
                    fontSize: 13,
                    lineHeight: 1.5,
                    resize: 'vertical'
                }}
            />
            {jsonError ? <FormHelperText error>{jsonError}</FormHelperText> : null}
            {error && !jsonError ? <FormHelperText error>{error}</FormHelperText> : null}
        </React.Fragment>
    );
}

export default JsonTextarea;
